import * as React from 'react';

import '@common/react/yupLocaleSettings';
import loadable from '@common/react/loadable/loadableSettings';
import { ErrorBoundaryWithLocation } from '@common/react/components/UI/ErrorBoundary/ErrorBoundary';
import { LoaderProvider } from '@common/react/components/Core/LoaderProvider/LoaderProvider';
import { NotFoundPageProvider } from '@common/react/components/Core/NotFoundPageProvider/NotFoundPageProvider';
import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';
import Application from '@common/react/components/Core/Application/Application';
import BaseModalContextProvider from '@common/react/components/base/BaseModalContextProvider/BaseModalContextProvider';
import GoogleKeysProvider from '@common/react/components/google/GoogleKeysProvider/GoogleKeysProvider';
import GoogleTagManager from '@common/react/components/google/GoogleTagManager/GoogleTagManager';

import TranslatedLoader from '@app/components/UI/Loaders/TranslatedLoader';
import ReduxProvider from '@app/hooks/useReduxContext';
import { User } from '@app/objects/User';
import { Init } from '@app/objects/Init';
import InitI18n from '@app/components/InitLang';

import '@app/scss/style.scss';
import '@app/scss/vendor.scss';

const CustomNotFoundPage = loadable(() =>
	import(/* webpackChunkName: "CustomNotFoundPage" */ '@app/components/Pages/NotFoundPage/NotFoundPage'));

const Layout: React.FC = ({ children }) => <div className="app-container">
	<ErrorBoundaryWithLocation>
		<ReduxProvider>
			{({ companySettings: { googleAnalyticsId, googleApiKey, googleTagManagerId } }) =>
				<GoogleKeysProvider
					analyticsId={googleAnalyticsId}
					mapKey={googleApiKey}
					tagManagerId={googleTagManagerId}
				>
					<GoogleTagManager />
					<RequestProvider ttl={120000} errorComponents={{ notFound: () => <CustomNotFoundPage /> }}>
						<Application<User, Init> withoutSignalR>
							<InitI18n>
								<NotFoundPageProvider notFoundComponent={(() => <CustomNotFoundPage />) as any}>
									<LoaderProvider
										loader={<TranslatedLoader />}
										other={{
											chunkLoader: <TranslatedLoader />,
										}}
									>
										<BaseModalContextProvider>
											{children}
										</BaseModalContextProvider>
									</LoaderProvider>
								</NotFoundPageProvider>
							</InitI18n>
						</Application>
					</RequestProvider>
				</GoogleKeysProvider>
			}
		</ReduxProvider>
	</ErrorBoundaryWithLocation>
</div>;

export default Layout;
